import {React, styled} from 'common'
import RawDialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import {DialogActions} from '@mui/material'
import Button from 'components/Control/Button'
import {useIsRtl} from 'store/Store'
import useResponsive from 'logic/useResponsive'
import DialogTitle from './DialogTitle'
import PageLoader from '../Loader/PageLoader'
import formDialogActions from 'constants/formDialogActions'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

const Dialog = ({
    open,
    onClose,
    onSubmit,
    scroll,
    title,
    children,
    itemName,
    handleSubmit,
    isLoading,
    withFormAction = true,
}) => {
    const isRtl = useIsRtl()
    const {t} = useTranslation()
    const handleClose = () => {
        onClose(false)
    }
    const {smallScreen} = useResponsive()
    const size = smallScreen ? '100%' : '80%'
    const fromActions = useMemo(() => formDialogActions?.[itemName], [itemName])
    if (isLoading) return <PageLoader show={true} />

    return (
        <RawDialogStyled
            open={open}
            // onClose={handleClose}
            scroll={scroll}
            fullWidth
            maxWidth={size}
            sx={{'& .MuiDialog-paper': {width: size, height: size}}}>
            <DialogTitle id="scroll-dialog-title" title={title} onClose={handleClose} />
            <DialogContent
                dir={isRtl ? 'rtl' : 'ltr'}
                dividers={scroll === 'paper'}
                style={{padding: '10px 20px'}}>
                {children}
            </DialogContent>
            {withFormAction && (
                <DialogActions>
                    {fromActions &&
                        fromActions.map((action, index) => {
                            const ActionComponent = action.Component
                            return <ActionComponent key={index} handleSubmit={handleSubmit} />
                        })}
                    {/* <Button>{t('modal.cancel')}</Button> */}
                    <Button onClick={onSubmit} variant="contained">
                        {t('modal.submit')}
                    </Button>
                </DialogActions>
            )}
        </RawDialogStyled>
    )
}

export default Dialog

const RawDialogStyled = styled(RawDialog)`
    /* width: 100%;
    height: 100%;
    .MuiDialog-paper {
        width: ${({size}) => size} !important;
        height: ${({size}) => size} !important;
    } */
    /* .MuiDialogTitle-root {
        padding: 10px 20px;
    }
    .MuiDialogContent-root {
        padding: 10px 20px;
    }
    .MuiDialogActions-root {
        padding: 10px 20px;
    }
    .MuiButton-root {
        margin-left: 10px;
    } */
`
